import { render, staticRenderFns } from "./patrolReceive.vue?vue&type=template&id=15cf088b&scoped=true&"
import script from "./patrolReceive.vue?vue&type=script&lang=ts&"
export * from "./patrolReceive.vue?vue&type=script&lang=ts&"
import style0 from "./patrolReceive.vue?vue&type=style&index=0&id=15cf088b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf088b",
  null
  
)

export default component.exports